import axios from "axios"

export const submitLogin = (email: string, password: string): Promise<any> => {
  return axios.post('/api/auth/login', {
    email: email,
    password: password
  })
}

export const logout = () => {
  return axios.post('/api/auth/logout')
}

export const getMe = (): Promise<any> => {
  return axios.post('/api/auth/me')
}